import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { routing } from './app-routing.module';
import { CoreModule, provideEnvironment } from './core/core.module';
import { AppComponent } from './app.component';
import { MapModule } from '@realpage-da/ng-map';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SharedModule } from '~shared/shared.module';
import { RecaptchaService } from './core/services/recaptcha.service';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RECAPTCHA_BASE_URL, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/auditTime';

import 'rxjs/add/observable/combineLatest';
import { environment } from '~environment';
import { CaptchaModule } from '~/captcha/captcha.module';
import { RecaptchaInterceptor } from './captcha/interceptors/recaptcha.interceptor';
import { SearchService } from './shared/components/search/services';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CoreModule.forRoot(provideEnvironment(environment)),
    SharedModule,
    routing,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgbModule.forRoot(),
    MapModule.forGoogle(),
    CaptchaModule.forRoot({ siteKey: environment.reCaptchaKey }),
    RecaptchaV3Module
  ],
  providers: [
    RecaptchaService,
    SearchService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RecaptchaInterceptor,
      multi: true
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.reCaptchaKey // Use environment variable instead of hardcoded value
    },
    {
      provide: RECAPTCHA_BASE_URL,
      useValue: 'https://www.google.com/recaptcha/api.js'
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'en'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts